import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Paintings} from '../shared/Paintings';
import {PopupComponent} from '../popup/popup.component';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { backendAddress } from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import { ElementRef } from '@angular/core';
import {LanguageService} from '../service/language.service';

@Component({
    selector: 'app-edit-art',
    templateUrl: './edit-art.component.html',
    styleUrls: ['./edit-art.component.scss'],
    standalone: false
})

export class EditArtComponent implements OnInit {
  @ViewChildren('lazyElement', { read: ElementRef }) lazyElements!: QueryList<ElementRef>;
  @Input() loggedInUser: any;
  router: Router;

  constructor(public dialog: MatDialog, private privateRouter: Router, private api: ConfigService,
              // tslint:disable-next-line:variable-name
              private snackBar: MatSnackBar, private translate: TranslateService, private _language: LanguageService ) {
    this.router = privateRouter;
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }
  isLoaderVisible = false;
  isDataReady = false;
  paintings = [
    {
      id: 0,
      title: '',
      description: '',
      picture_category_id: 0,
      availability: 0,
      dimension: '',
      technique: '',
      year: 0,
      file_name: '',
      user_id: 0,
      created_at: '',
      updated_at: '',
      file_path: '',
    }
  ];
  isEditArtVisible = false;
  toSendPainting = [];
  backendAddress = backendAddress.value;

  getArtObjects(): void {
    this.isLoaderVisible = true;
    this.api.getLoggedInArtistArtObjects().subscribe(data => {
        // @ts-ignore
        this.paintings = data.reverse();
        this.isLoaderVisible = false;
        this.isDataReady = true;
        setTimeout(() => {
          this.initiateLazyLoad();
        }, 0);
      },
      error => {
        console.log('getLoggedInUserArtObjects error', error);
        this.isLoaderVisible = false;
        this.isDataReady = true;
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
        // TODO
        // const data =  [
        //   {
        //     id: 87,
        //     title: 'tablou 8 martie',
        //     description: 'Tablou cu art print de 8 martie',
        //     picture_category_id: 5,
        //     availability: 0,
        //     dimension: '20x30cm',
        //     technique: 'art print',
        //     year: 2025,
        //     file_name: '165.jpg',
        //     price: null,
        //     user_id: 15,
        //     created_at: '2025-04-05T17:07:49.000000Z',
        //     updated_at: '2025-04-05T17:07:49.000000Z',
        //     file_path: 'storage\/art-object\/87\/165.jpg'
        //   },
        //   {
        //     id: 88,
        //     title: 'titlu',
        //     description: 'desc',
        //     picture_category_id: 5,
        //     availability: 1,
        //     dimension: 'a3',
        //     technique: 'tehnica',
        //     year: 1202,
        //     file_name: null,
        //     price: 200,
        //     user_id: 15,
        //     created_at: '2025-04-09T14:40:59.000000Z',
        //     updated_at: '2025-04-09T14:40:59.000000Z',
        //     file_path: 'storage\/art-object\/88\/'
        //   },
        //   {
        //     id: 89,
        //     title: 'bufnita',
        //     description: 'descr',
        //     picture_category_id: 4,
        //     availability: 1,
        //     dimension: '12',
        //     technique: 'acryluic',
        //     year: 2023,
        //     file_name: null,
        //     price: 122,
        //     user_id: 15,
        //     created_at: '2025-04-10T06:49:12.000000Z',
        //     updated_at: '2025-04-10T06:49:12.000000Z',
        //     file_path: 'storage\/art-object\/89\/'
        //   },
        //   {
        //     id: 90,
        //     title: 'lup',
        //     description: 'e',
        //     picture_category_id: 4,
        //     availability: 1,
        //     dimension: 'w',
        //     technique: 'ew',
        //     year: 1221,
        //     file_name: null,
        //     price: 12,
        //     user_id: 15,
        //     created_at: '2025-04-10T06:52:28.000000Z',
        //     updated_at: '2025-04-10T06:52:28.000000Z',
        //     file_path: 'storage\/art-object\/90\/'
        //   },
        //   {
        //     id: 91,
        //     title: 'as',
        //     description: 'ss',
        //     picture_category_id: 4,
        //     availability: 1,
        //     dimension: 'sas',
        //     technique: 'asas',
        //     year: 2212,
        //     file_name: null,
        //     price: 212,
        //     user_id: 15,
        //     created_at: '2025-04-10T06:56:09.000000Z',
        //     updated_at: '2025-04-10T06:56:09.000000Z',
        //     file_path: 'storage\/art-object\/91\/'
        //   }
        // ];
        // @ts-ignore
        // this.paintings = data;
        // console.log('this paintigns', this.paintings);

        // setTimeout(() => {
        //   this.initiateLazyLoad();
        // }, 0);
      });
  }

  deletePainting(painting: Paintings): void{
    this.isLoaderVisible = true;
    this.api.deleteArtObject(String(painting)).subscribe(data => {
        this.getArtObjects();
        this.isLoaderVisible = false;
        this.translate.get('objectSuccessfullyDeleted').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'success-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      },
      error => {
        console.log('something went wrong error', error);
        this.translate.get('errorOccurred').subscribe(message => {
          this.isLoaderVisible = false;
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      });
  }

  openDialogDeleteObject(artObject: any): void {
    this.translate.get('sureYouWantToDelete').subscribe(message => {
      const dialogRef = this.dialog.open(PopupComponent, {
        data: {popupText: message, popupButtonsNotVsible: 'nu'},
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === true){
          this.deletePainting(artObject.id);
        }
      });
    });
  }
  editArt(painting: any): void {
    this.isEditArtVisible = true;
    this.toSendPainting = painting;
  }
  cancelEdit(): void {
    this.isEditArtVisible = false;
    setTimeout(() => {
      this.initiateLazyLoad();
    }, 0);
  }
  initiateLazyLoad(): void {
    // tslint:disable-next-line:no-shadowed-variable
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target); // Stop observing once it's visible
        }
      });
    }, { threshold: 0.1 }); // Trigger when 10% of the element is visible

    // Observe each lazy-load element
    this.lazyElements.forEach(element => observer.observe(element.nativeElement));
  }
  ngOnInit(): void {
    if (this.loggedInUser.role_id !== 3) {
      this.getArtObjects();
    } else {
      this.isDataReady = true;
    }
  }

}
